<script setup lang="ts">
import { ref } from 'vue';
import { IconBaselineMap, IconBaselineSatellite } from '@iconify-prerendered/vue-ic';
import type { MapApi, BaseLayerType } from './MapView.vue';
import { useTranslations } from 'shared/translations/composables/useTranslations.ts';

const props = defineProps<{
  mapApi: MapApi,
}>();

const translations = useTranslations();
const selectedBaseLayer = ref<BaseLayerType>(props.mapApi.baseLayer);

function toggle() {
  const next: BaseLayerType = selectedBaseLayer.value === 'satellite' ? 'osm' : 'satellite';
  selectedBaseLayer.value = next;
  props.mapApi.setBaseLayer(next);
}
</script>

<template>
  <button type="button" class="base-layer-toggle"
    :aria-pressed="selectedBaseLayer === 'satellite'" aria-label="Select base map layer" @click="toggle">
    <IconBaselineMap v-if="selectedBaseLayer === 'satellite'" />
    <IconBaselineSatellite v-else />
    <span>{{ selectedBaseLayer === 'satellite' ? translations.generic.map : translations.generic.satellite }}</span>
  </button>
</template>

<style scoped>
.base-layer-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;

  padding: 0.5rem;
  height: 2.0rem;
  min-width: 2.0rem;
  box-sizing: border-box;

  border: 1px solid var(--p-primary-color);
  border-radius: 6px;
  background: var(--p-content-background, #fff);
  color: var(--p-primary-color);

  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  font: inherit;
}

.base-layer-toggle > svg {
  display: block;
  width: 1.25rem;
  height: 1.25rem;
  flex-shrink: 0;
}

.base-layer-toggle > span {
  line-height: 1;
}

.base-layer-toggle:hover {
  border-color: var(--p-primary-color);
}
</style>
